import { Trans, useTranslation } from "react-i18next"

import FormattedComment from "components/lib/FormattedComment"
import util from "utils/utils"

export default function IdeaCommentedContent({ events, ownerIdea }) {
  const { t } = useTranslation()
  const textSuffix = events[0]?.isFollower ? `${t("generic.ideaWithArticle")} you follow` : `your ${t("generic.idea")}`

  return (
    <Trans
      i18nKey="notifications.ideaCommented"
      values={{
        name: util.getEventNames(events),
        suffix: textSuffix,
        idea: ownerIdea?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink />,
      }}
    />
  )
}
